import { Flex } from 'antd';
import styled from 'styled-components';
import { ImageContainer } from '../../styles/commonStyles';

export const Container = styled(Flex)`
  width: 100%;
  &.checkable {
    padding: 16px;
  }
  &.checked {
    background: #f4f9ec;
  }
`;

export const StepImageContainer = styled(ImageContainer)`
  width: 80px;
  height: 60px;
`;

export const DeleteButton = styled.div`
  padding: 12px;
  cursor: pointer;
  font-size: 18px;
  color: #999;
  :hover {
    color: ${(props) => props.theme.antd?.colorPrimary};
  }
`;

export const CauseName = styled.p`
  font-weight: 500;
  margin: 0;
  line-height: 22px;
  font-size: 12px;
`;

export const Description = styled.p`
  margin: 0;
  line-height: 22px;
  font-size: 12px;
  color: #85878b;
`;

export const StepSigns = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
`;

export const StepSignImage = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;
`;
